import React, { useMemo } from 'react';
import cs from 'classnames';
import { NOTECARD_EDITOR_FONTS, NOTECARD_EDITOR_STYLES_MAP } from '../constants';
import { NotecardEditorSelectWrapper } from '../notecard-editor-select-wrapper';
import { getStyleValueForPrefix } from '../helpers';
import classes from './notecard-editor-select-font.scss';
import animationClasses from './notecard-editor-select-font-animation.scss';
const fontsEntries = Object.entries(NOTECARD_EDITOR_FONTS);
const FONT_PREFIX = NOTECARD_EDITOR_STYLES_MAP.FONT_FAMILY_PREFIX;
export const NotecardEditorSelectFont = ({
  selectionStyles,
  handleSelectStyleChange,
  isOpened,
  toggleOpened
}) => {
  const selectedFontValue = useMemo(() => {
    const foundFont = getStyleValueForPrefix(selectionStyles, FONT_PREFIX);
    if (!foundFont) {
      return null;
    }
    return foundFont.replace(FONT_PREFIX, '');
  }, [selectionStyles, isOpened]);
  const handleFontChange = label => {
    handleSelectStyleChange(label, FONT_PREFIX);
  };
  const selectedFontLabel = selectedFontValue !== null && selectedFontValue !== void 0 ? selectedFontValue : 'Font';
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(NotecardEditorSelectWrapper, {
    isOpened: isOpened,
    animationClasses: animationClasses,
    name: selectedFontLabel,
    toggleOpened: toggleOpened
  }, /*#__PURE__*/React.createElement(React.Fragment, null, fontsEntries.map(([key, label]) => /*#__PURE__*/React.createElement("div", {
    className: cs(classes.item, {
      [classes.itemSelected]: selectedFontValue === label
    }),
    key: key,
    onClick: () => handleFontChange(label)
  }, label)))));
};